/**
 * Shared types + helpers for scene components.
 */

import type { Scene } from '@/types/gameSpec';
import type { SceneType } from '@/components/games/dynamic/manifest';

export interface SceneComponentProps<S extends Scene = Scene> {
  scene: S;
  onAnswer: (isCorrect: boolean, details?: Record<string, unknown>) => void;
}

/** Fisher–Yates shuffle that preserves the original array. */
export function shuffle<T>(arr: readonly T[]): T[] {
  const out = arr.slice();
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [out[i], out[j]] = [out[j], out[i]];
  }
  return out;
}

export function normalize(s: string, caseSensitive?: boolean): string {
  const t = s.trim();
  return caseSensitive ? t : t.toLowerCase();
}

export const SCENE_LABEL: Record<SceneType, string> = {
  mcq: 'Multiple choice',
  fill_blank: 'Fill in the blank',
  flashcard: 'Flashcard',
  matching: 'Matching',
  ordering: 'Put in order',
  drag_to_bucket: 'Sort into buckets',
  number_line: 'Number line',
  worked_steps: 'Worked steps',
  reading: 'Reading',
  sprint: 'Sprint',
  tap_correct: 'Tap the correct ones',
  memory_pairs: 'Memory pairs',
  sequence_input: 'Enter the sequence',
};
